import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  Modal,
  Row,
  Col,
  FormControl,
  FormGroup,
  Button,
  ControlLabel,
  Form,
  Tabs,
  Tab,
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import WorkdocStore from "../../stores/WorkdocStore";
import PODocStore from "../../stores/PODocStore";
import CKAutocomplete from "../../component/element/CKAutocomplete";
import IframeModal from "../../component/element/IframeModal";
import { Checkbox } from "react-icheck";
import Moment from "moment";
import Select from "react-select";
import $ from "jquery";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import "./po.css";
import _ from 'lodash'

const yTh = parseInt(Moment().format("YYYY")) + 543;
const create_date = Moment()
  .format("L LT")
  .replace(Moment().format("YYYY"), yTh);
const NotificationSystem = require("react-notification-system");
class POOutstandingRecordModal extends Component {
  constructor(...args) {
    super(...args);
    let { messages } = this.props;
    this.state = {
      data: [],
      doc: {},
      poNo: "",
      receiveDataAuto: [],
      receiveCheck: [],
      receiveCheckAll: false,
      receiveAutoCheck: [],
      receiveAutoCheckAll: false,
      dataReceived: [],
      input: {
        date: create_date,
        response_by: "",
        request_by: "",
        description: "",
        barcode: "",
        deliveryslip_no: "",
        taxinvoice_no: "",
      },
      itemReceived: [],
      itemReturn: [],
      valid: this.initValidState(),
      customerList: [],
      stockApproverList: [],
      barcodeMsg: "",
      barcodeMsgColor: "",
      checkSaveReceive: true,
      show_auto_create_stock: false,
      auto_create_stock: false,
      toolType: "genpart",
      oriItem: [],
      partByTitle: messages["All"],
      part_by: {
        garage: false,
        branch: false,
        insurance: false,
        customer: false,
      },
      isDelivery: false,
      tabKey: "home",
      checkAutoCreate: false,
      config:{required_fields:[]}
    };
    this.optionsToolType = [
      { value: "tool", label: messages["Tool"] },
      { value: "genpart", label: messages["General Part"] },
      { value: "officemate", label: messages["Officemate"] },
      { value: "color", label: messages["Color"] },
    ];
  }

  componentDidMount() {
    $("body").on("click", () => {
      if ($(".btn-group-link").hasClass("open")) {
        $(".table-po").css("overflow-x", "auto");
        $(".table-po").css("overflow-y", "");
      } else {
        $(".table-po").css("overflow-x", "initial");
        $(".table-po").css("overflow-y", "unset");
      }
    });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show && newProps.show !== this.props.show) {
      this.loadPORecord(
        newProps.recordType,
        newProps.doc.purchase_order_no,
        newProps.data
      );
      this.setState({
        poNo: newProps.doc.purchase_order_no,
        doc: newProps.doc,
        data: newProps.data,
        barcodeMsg: "",
        barcodeMsgColor: "",
        checkSaveReceive: true,
      });
    }
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this;
    let officer = [];
    WorkdocStore.loadWorkdocAutocompleteOfficer(function (result) {
      result.data.forEach((element) => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id,
        });
      });
      that.setState({ customerList: officer });
    });
  }

  loadWorkdocAutocompleteStockApprover() {
    let approver = [];
    WorkdocStore.loadWorkdocAutocompleteStockApprover((result) => {
      result.data.forEach((element) => {
        approver.push({
          id: element.Value,
          label: element.Name,
        });
      });
      this.setState({ stockApproverList: approver });
    });
  }

  loadPORecord(recordType, poNo, data) {
    let { mode, workNo } = this.props;
    if (recordType === "RECEIVED") {
      if (mode === "workdoc-po") {
        WorkdocStore.loadPartOutstandingRecord(recordType, workNo, (result) => {
          this.processPOState(result, data);
        });
      } else {
        PODocStore.loadPOOutRecord(recordType, poNo, (result) => {
          this.processPOState(result, data);
        });
      }
    } else if (recordType === "EXPORTWORK") {
      if (mode === "workdoc-po") {
        WorkdocStore.loadPartOutstandingRecord(recordType, workNo, (result) => {
          this.processPOState(result, data);
        });
      } else {
        PODocStore.loadPOOutRecord(recordType, poNo, (result) => {
          this.processPOState(result, data);
        });
      }
    } else if (recordType === "RETURN") {
      if (mode === "workdoc-po") {
        WorkdocStore.loadPartOutstandingRecord(recordType, workNo, (result) => {
          this.processPOState(result, data);
        });
      } else {
        PODocStore.loadPurchaseReceivedRecord(poNo, (result) => {
          this.processPOState(result, data);
        });
      }
    } else if (recordType === "IMPORT_STOCK") {
      if (mode === "workdoc-po") {
        WorkdocStore.loadPartOutstandingRecord(recordType, workNo, (result) => {
          let check = false;
          result.data.forEach((item, index) => {
            if (this.getRowClassName(item, index) == "bg-gray") check = true;
          });
          this.setState({ show_auto_create_stock: check });
          this.processPOState(result, data);
        });
      } else {
        PODocStore.loadPOOutRecord(recordType, poNo, (result) => {
          let check = false;
          result.data.forEach((item, index) => {
            if (this.getRowClassName(item, index) == "bg-gray") check = true;
          });
          this.setState({ show_auto_create_stock: check });
          this.processPOState(result, data);
        });
      }
    }
  }

  getRowClassName(item, index) {
    let { rowBeep } = this.state;
    let className =
      item.itemnum > 0 ? "" : item.detail.length > 0 ? "bg-gray" : "";

    if (rowBeep === index) {
      className = "bg-yellow";
    }
    return className;
  }

  processPOState(result, data) {
    let { input, itemReceived, itemReturn ,config} = this.state;
    let { recordType } = this.props;
    let oriItem = [];
    itemReceived = [];
    itemReturn = [];

    // input.added_date = result.data.added_date
    // input.description = result.data.description
    // input.request_by = result.data.request_by
    // input.response_by = result.data.response_by

    let receiveCheck = [];
    let checkItemnum = [];
    if (recordType === "RETURN") {
      result.data.forEach(function (item, index) {
        if (checkItemnum.indexOf(item.bf_purchase_order_item_id) === -1) {
          checkItemnum.push(item.bf_purchase_order_item_id);
          itemReturn.push(item);
        }
      });
      oriItem = JSON.parse(JSON.stringify(itemReturn));
    } else {
      result.data.forEach(function (item, index) {
        itemReceived.push(item);
      });
      oriItem = JSON.parse(JSON.stringify(itemReceived));
    }

    let _items = [];
    _items = recordType === "RETURN" ? itemReturn : itemReceived;
    _items.forEach(function (item, index) {
      if (
        item.seq !== undefined ||
        item.amount !== "" ||
        item.detail !== "" ||
        item.itemnum !== "" ||
        item.price_per_unit !== "" ||
        item.productcode !== "" ||
        item.quantity !== ""
      )
        receiveCheck.push(false);
    });

    this.loadWorkdocAutocompleteOfficer();
    this.loadWorkdocAutocompleteStockApprover();

    let valid = this.initValidState()
    this.setState({
      dataReceived: result.data,
      showReceive: true,
      input: input,
      valid: valid,
      receiveCheck: receiveCheck,
      receiveCheckAll: false,
      itemReceived: itemReceived,
      itemReturn: itemReturn,
      oriItem: oriItem,
      config:Object.assign(config,(result.config?result.config:null))
    });
  }

  initValidState(){
    return _.clone({
      request_by: { id: null, state: null, has_error: "" },
      response_by: { id: null, state: null, has_error: "" },
      deliveryslip_no: { id: null, state: null, has_error: "" },
      taxinvoice_no: { id: null, state: null, has_error: "" },
    })
  }

  onReceiveTextSelect(key, e) {
    let { input } = this.state;
    input[key] = e;
    this.setState({ input: input });
    if (key == "request_by") {
      this.refs._response_by.onFocus();
    } else if (key == "response_by") {
      ReactDOM.findDOMNode(this.refs._description).focus();
    }
  }

  onReceiveTextChange(key, e) {
    let { input, isDelivery } = this.state;
    input[key] = e.target.value;
    if (isDelivery && key === "deliveryslip_no")
      input.taxinvoice_no = e.target.value;
    this.setState({ input: input });
  }

  onDeliveryChange() {
    let { isDelivery, input } = this.state;
    isDelivery = isDelivery ? false : true;
    if (isDelivery) input.taxinvoice_no = input.deliveryslip_no;
    this.setState({ isDelivery: isDelivery, input: input });
  }

  onReceiveSearchKeyPress(e) {
    if (e.charCode === 13) {
      let { input } = this.state;
      let { recordType, messages } = this.props;
      if (e.target.value !== "") {
        let checkBarcode = false;
        let {
          itemReceived,
          itemReturn,
          receiveCheck,
          barcodeMsg,
          barcodeMsgColor,
        } = this.state;
        let _items = [];
        _items = recordType === "RETURN" ? itemReturn : itemReceived;
        _items.forEach(function (item, index) {
          if (item.seq !== undefined) {
            if (item.productcode === e.target.value) {
              checkBarcode = true;
              receiveCheck[index] = true;
            }
          }
        });
        let msg = "";
        let color = "";
        if (checkBarcode === true) {
          msg =
            messages["Code"] +
            " " +
            e.target.value +
            " " +
            messages["Check Correct"];
          color = "rgba(0, 166, 90, 0.67)";
        } else {
          msg = messages["Product Code Not Found"] + " " + e.target.value;
          color = "#dd4b39";
        }
        input.barcode = "";

        let isReceiveCheckAll = true;
        receiveCheck.forEach(function (item, index) {
          if (!item) isReceiveCheckAll = false;
        });
        this.setState({
          receiveCheck: receiveCheck,
          barcodeMsg: msg,
          barcodeMsgColor: color,
          input: input,
          receiveCheckAll: isReceiveCheckAll,
        });
      }
    }
  }

  onCancelClick() {
    this.props.onHide();
    this.setState({ auto_create_stock: false, tabKey: "home" });
  }

  onReceiveClick() {
    let { auto_create_stock, checkAutoCreate } = this.state;
    if (auto_create_stock && checkAutoCreate) {
      Swal.fire({
        icon: "warning",
        title: "มีสินค้าในคลังแล้ว ต้องการอัปเดทหรือสร้างสินค้าตัวใหม่?",
        showDenyButton: true,
        confirmButtonText: "อัปเดท",
        denyButtonText: "สร้างใหม่",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#218838",
      }).then((result) => {
        if (result.isConfirmed) {
          this.saveReceive();
        } else if (result.isDenied) {
          this.setState({ checkAutoCreate: false, tabKey: "create-auto" });
        }
      });
    } else {
      this.saveReceive();
    }
  }

  checkRequireField(input,valid,key){
    
    if (
      input[key] === "" ||
      input[key] === null ||
      input[key] === undefined
    ) {

      valid[key].id = "formValidationError";
      valid[key].state = "error";
      valid[key].has_error = "has-error";
      this.setState({ valid: Object.assign(this.initValidState(),valid), checkSaveReceive: true });
      return false;
    }    
    return true;
  }

  saveReceive(completeSaveFunc) {
    let {
      doc,
      input,
      receiveCheck,
      itemReceived,
      itemReturn,
      oriItem,
      valid,
      checkSaveReceive,
      show_auto_create_stock,
      auto_create_stock,
      toolType,
      receiveAutoCheck,
      receiveDataAuto,
      config
    } = this.state;
    let { mode, workNo } = this.props;
    let receiveAutoList = [];
    receiveAutoCheck.forEach((checked, index) => {
      if (checked || receiveDataAuto[index].itemnum === "0") {
        receiveAutoList.push(receiveDataAuto[index]);
      }
    });
    if (checkSaveReceive) {
      this.setState({ checkSaveReceive: false });
      let { recordType, messages } = this.props;
      let items = [];
      let _items = [];
      _items = recordType === "RETURN" ? itemReturn : itemReceived;
      _items.forEach(function (item, index) {
        if (receiveCheck[index]) items.push(item);
      });


      if(!this.checkRequireField(input,valid,'request_by')){
        return false
      }

      if(!this.checkRequireField(input,valid,'response_by')){
        return false
      }

      let invalid = config.required_fields.find((item,index)=>{
        return !this.checkRequireField(input,valid,item)          
      })
      if(invalid){
        return false
      }

      let description = input.description;
      if (input.description === undefined) description = "";

      let checked = false;
      receiveCheck.forEach(function (item, index) {
        if (item) checked = true;
      });

      if (receiveCheck.length === 0 || !checked) {
        this.refs.notificationSystem.addNotification({
          title: messages["Notice"],
          message: messages["Select Least One Item"],
          level: "error",
          position: "tc",
        });
        this.setState({ checkSaveReceive: true });
        return false;
      }

      this.setState({ loading: true });
      let postData = {
        meta: {
          description: description,
          request_by: input.request_by,
          response_by: input.response_by,
          record_type: this.props.recordType,
          shop_id: doc.shop_id,
          purchase_order_no: doc.purchase_order_no,
          work_no: doc.work_no,
        },
        item: items,
      };

      if (recordType === "IMPORT_STOCK") {
        postData.autocreate_list = receiveAutoList;
        postData.meta = Object.assign(
          {
            auto_create_stock: auto_create_stock,
            create_stock_category: toolType,
          },
          postData.meta
        );
        let check_0_itemnum = false;
        postData.item.forEach((item, index) => {
          if (
            item.itemnum === "0" ||
            item.itemnum === "" ||
            item.itemnum === 0 ||
            item.itemnum === null
          ) {
            check_0_itemnum = true;
          }
        });
        if (show_auto_create_stock && !auto_create_stock && check_0_itemnum) {
          this.refs.notificationSystem.addNotification({
            title: messages["Notice"],
            message: messages["Gray Stripe"],
            level: "error",
            position: "tc",
          });
          this.setState({ checkSaveReceive: true });
          return false;
        }
      }

      let validQty = true;
      postData.item.forEach((item, index) => {
        let key = oriItem.findIndex(
          (x) => x.bf_purchase_order_item_id === item.bf_purchase_order_item_id
        );
        if (key !== -1) {
          let qty =
            item.quantity !== "" &&
            item.quantity !== undefined &&
            item.quantity !== null &&
            !isNaN(item.quantity)
              ? item.quantity
              : 0;
          if (qty < 0 || qty > oriItem[key].quantity) {
            validQty = false;
          }
        }
      });

      if (!validQty) {
        this.refs.notificationSystem.addNotification({
          title: messages["Notice"],
          message: messages["Amount Less 0"],
          level: "error",
          position: "tc",
        });
        this.setState({ checkSaveReceive: true });
        return false;
      }

      if (mode === "workdoc-po") {
        postData.meta.work_no = workNo;
        postData.meta.shop_id = "";
        WorkdocStore.savePartRecord(
          postData,
          (result) => {
            if (result.result === "OK") {
              this.afterSave(result, items);
            }
            if (completeSaveFunc != undefined) completeSaveFunc();
          },
          () => {
            this.setState({ checkSaveReceive: false });
          }
        );
      } else {
        if (recordType === "RECEIVED")
          postData.meta = Object.assign(
            {
              deliveryslip_no: input.deliveryslip_no,
              taxinvoice_no: input.taxinvoice_no,
            },
            postData.meta
          );

        PODocStore.savePORecord(
          postData,
          (result) => {
            if (result.result === "OK") {
              this.afterSave(result, items);
            }
            if (completeSaveFunc !== undefined) completeSaveFunc();
          },
          () => {
            this.setState({ checkSaveReceive: false });
          }
        );
      }
    }
  }

  afterSave(result, items) {
    let { input, itemReceived, oriItem } = this.state;
    let { messages, recordType } = this.props;
    this.refs.notificationSystem.addNotification({
      title: messages["Notice"],
      message: messages["Save Successfully"],
      level: "info",
      position: "tc",
    });

    let receiveCheck = [];
    items.forEach(function (item, index) {
      receiveCheck.push(false);
    });

    let valid = this.initValidState()

    if (recordType === "IMPORT_STOCK") {
      result.newdata.forEach((item, index) => {
        const key = itemReceived.findIndex(
          (x) => x.bf_purchase_order_item_id == item.bf_purchase_order_item_id
        );
        if (key !== -1) {
          itemReceived[key] = Object.assign(itemReceived[key], {
            itemnum: item.itemnum,
            stock_type: item.stock_type,
          });
        }
      });
      if (this.props.onAutoCreateStockClick != undefined)
        this.props.onAutoCreateStockClick(itemReceived);

      oriItem = JSON.parse(JSON.stringify(itemReceived));
      this.setState({ itemReceived: itemReceived, oriItem: oriItem });
    }

    this.setState({
      checkSaveReceive: false,
      auto_create_stock: false,
      toolType: "genpart",
      loading: false,
      valid: valid,
      input: {
        date: create_date,
        response_by: "",
        request_by: "",
        description: "",
        barcode: "",
      },
    });
    if (this.props.onSavePORecord !== undefined) {
      this.props.onSavePORecord(input);
    }
    this.props.onHide();

    if (recordType === "RETURN") this.props.onAfterReturnClick(items);
    else if (recordType === "RECEIVED") this.props.onAfterReceivedClick(items);
    else if (recordType === "EXPORTWORK")
      this.props.onAfterExportWorkClick(items);
    else if (recordType === "IMPORT_STOCK")
      this.props.onAfterImportStockClick(items);
  }

  onReceiveChange(index, e, checked) {
    let { receiveCheck, receiveCheckAll } = this.state;

    let newReceiveCheck = [];

    if (index === "all") {
      if (checked) {
        receiveCheck.forEach(function (item, index) {
          newReceiveCheck.push(true);
        });
        this.setState({
          receiveCheckAll: true,
          receiveCheck: newReceiveCheck,
        });
      } else {
        receiveCheck.forEach(function (item, index) {
          newReceiveCheck.push(false);
        });
        this.setState({
          receiveCheckAll: false,
          receiveCheck: newReceiveCheck,
        });
      }
    } else {
      if (receiveCheck[index]) {
        receiveCheck[index] = false;
        receiveCheckAll = false;
      } else {
        receiveCheck[index] = true;
        if (receiveCheck.indexOf(false) === -1) receiveCheckAll = true;
      }
      this.setState({
        receiveCheck: receiveCheck,
        receiveCheckAll: receiveCheckAll,
      });
    }
    this.setState({ auto_create_stock: false });
  }

  onAutoReceiveChange(index, e, checked) {
    let { receiveAutoCheck, receiveAutoCheckAll } = this.state;

    let newReceiveCheck = [];

    if (index === "all") {
      if (checked) {
        receiveAutoCheck.forEach(function (item, index) {
          newReceiveCheck.push(true);
        });
        this.setState({
          receiveAutoCheckAll: true,
          receiveAutoCheck: newReceiveCheck,
        });
      } else {
        receiveAutoCheck.forEach(function (item, index) {
          newReceiveCheck.push(false);
        });
        this.setState({
          receiveAutoCheckAll: false,
          receiveAutoCheck: newReceiveCheck,
        });
      }
    } else {
      if (receiveAutoCheck[index]) {
        receiveAutoCheck[index] = false;
        receiveAutoCheckAll = false;
      } else {
        receiveAutoCheck[index] = true;
        if (receiveAutoCheck.indexOf(false) === -1) receiveAutoCheckAll = true;
      }
      this.setState({
        receiveAutoCheck: receiveAutoCheck,
        receiveAutoCheckAll: receiveAutoCheckAll,
      });
    }
  }

  onReceiveTextKeyPress(key, e) {
    if (e.charCode === 13) {
      let { messages } = this.props;
      e.preventDefault();

      let { customerList, input } = this.state;
      let checkSearch = false;
      let value = "";

      customerList.forEach(function (item, index) {
        if (item.emp_id === e.target.value) {
          checkSearch = true;
          value = item.id;
        }
      });

      if (checkSearch) {
        if (key == "request_by") {
          input[key] = value;

          this.refs._response_by.onFocus();
        } else if (key == "response_by") {
          input[key] = value;
          // this.refs._description.focus()
        }
      } else {
        input[key] = "";
        this.refs.notificationSystem.addNotification({
          title: messages["Notice"],
          message:
            messages["Code Not Found"] +
            " " +
            e.target.value +
            " " +
            messages["Please Try Again"],
          level: "error",
          position: "tc",
        });
      }
      this.setState({ input: input });
    }
  }

  onReceivePrintClick() {
    let { poNo, doc } = this.state;
    let { recordType } = this.props;

    let url = "";
    if (process.env.NODE_ENV == "development") {
      url =
        "./?startPage=PrintPurchaseReceivedDoc&po=" +
        poNo +
        "&shop=" +
        (doc.name === undefined || doc.name === null ? "" : doc.name) +
        "&car_registration=" +
        (doc.car_registration_no === undefined ||
        doc.car_registration_no === null
          ? ""
          : doc.car_registration_no) +
        "&type=" +
        recordType;
    } else {
      url =
        "./pdf/v2/?startPage=PrintPurchaseReceivedDoc&po=" +
        poNo +
        "&shop=" +
        (doc.name === undefined || doc.name === null ? "" : doc.name) +
        "&car_registration=" +
        (doc.car_registration_no === undefined ||
        doc.car_registration_no === null
          ? ""
          : doc.car_registration_no) +
        "&type=" +
        recordType;
    }
    this.refs.iframe.loadUrl(url);
  }

  onAutoCreateStockChange(e, checked) {
    let { itemReceived, itemReturn, receiveCheck } = this.state;
    let { recordType } = this.props;
    let rowsData = recordType === "RETURN" ? itemReturn : itemReceived;
    let newReceiveDataAuto = [];
    if (checked) {
      receiveCheck.forEach((isChecked, index) => {
        if (isChecked) {
          newReceiveDataAuto.push(rowsData[index]);
        }
      });
    }

    let genReceiveAutoCheck = [];
    newReceiveDataAuto.forEach((item) => {
      if (item.itemnum === "0") {
        genReceiveAutoCheck.push(true);
      } else {
        genReceiveAutoCheck.push(false);
      }
    });

    let checkNewCreate = newReceiveDataAuto.filter(
      (item) => item.itemnum !== "0"
    );

    this.setState({
      auto_create_stock: checked,
      receiveDataAuto: newReceiveDataAuto,
      receiveAutoCheck: genReceiveAutoCheck,
      checkAutoCreate: checkNewCreate.length > 0 ? true : false,
    });
  }

  onToolTypeChange(e) {
    this.setState({ toolType: e.value });
  }

  onQuantityChange(index, e) {
    let { itemReceived, itemReturn } = this.state;
    let { recordType } = this.props;
    let rowsData = recordType === "RETURN" ? itemReturn : itemReceived;
    rowsData[index].quantity = e.target.value;

    this.setState({ itemReceived: rowsData });
  }

  renderReceiveRowData() {
    let { itemReceived, itemReturn } = this.state;
    let { recordType, messages, mode } = this.props;
    let rowsData = recordType === "RETURN" ? itemReturn : itemReceived;
    if (rowsData.length === 0 || rowsData === undefined) {
      return (
        <tr>
          <td
            colSpan={
              recordType === "RETURN"
                ? 6
                : recordType === "RECEIVED" && mode === "workdoc-po"
                ? 8
                : 7
            }
          >
            {messages["No Data"]}
          </td>
        </tr>
      );
    } else {
      return rowsData.map((item, index) => {
        if (
          item.seq !== undefined ||
          item.amount !== "" ||
          item.detail !== "" ||
          item.itemnum !== "" ||
          item.price_per_unit !== "" ||
          item.productcode !== "" ||
          item.quantity !== ""
        ) {
          return (
            <tr key={index} className={this.getRowClassName(item, index)}>
              <td className="text-center">
                <Checkbox
                  onChange={this.onReceiveChange.bind(this, index)}
                  checked={this.state.receiveCheck[index]}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                ></Checkbox>
              </td>
              <td className="text-center">{index + 1}</td>
              <td className="text-center">{item.productcode}</td>
              <td>{item.detail}</td>
              {recordType === "RETURN" ? (
                ""
              ) : (
                <td className="text-center">{item.record_quantity}</td>
              )}
              <td className="text-center">
                <FormControl
                  className="text-center"
                  value={item.quantity}
                  onChange={this.onQuantityChange.bind(this, index)}
                />
              </td>
              <td className="text-center">{item.unit}</td>
              {recordType === "RECEIVED" && mode === "workdoc-po" ? (
                <td className="text-center">
                  {item.part_by === "garage"
                    ? "อู่"
                    : item.part_by === "branch"
                    ? "สาขา"
                    : item.part_by === "insurance"
                    ? "ประกัน"
                    : "ลูกค้า"}
                </td>
              ) : (
                ""
              )}
            </tr>
          );
        }
      });
    }
  }

  renderAutoReceiveRowData() {
    let { receiveDataAuto, itemReturn } = this.state;
    let { recordType, messages, mode } = this.props;
    let rowsData = recordType === "RETURN" ? itemReturn : receiveDataAuto;

    if (rowsData.length === 0 || rowsData === undefined) {
      return (
        <tr>
          <td
            colSpan={
              recordType === "RETURN"
                ? 6
                : recordType === "RECEIVED" && mode === "workdoc-po"
                ? 8
                : 7
            }
          >
            {messages["No Data"]}
          </td>
        </tr>
      );
    } else {
      return rowsData.map((item, index) => {
        if (
          item.seq !== undefined ||
          item.amount !== "" ||
          item.detail !== "" ||
          item.itemnum !== "" ||
          item.price_per_unit !== "" ||
          item.productcode !== "" ||
          item.quantity !== ""
        ) {
          return (
            <tr key={index} className={this.getRowClassName(item, index)}>
              <td className="text-center">
                {item.itemnum > 0 ? (
                  <Checkbox
                    onChange={this.onAutoReceiveChange.bind(this, index)}
                    checked={this.state.receiveAutoCheck[index]}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=""
                  ></Checkbox>
                ) : null}
              </td>
              <td className="text-center">{index + 1}</td>
              <td className="text-center">{item.productcode}</td>
              <td>{item.detail}</td>
              {recordType === "RETURN" ? (
                ""
              ) : (
                <td className="text-center">{item.record_quantity}</td>
              )}
              <td className="text-center">
                <FormControl
                  disabled
                  className="text-center"
                  value={item.quantity}
                  onChange={this.onQuantityChange.bind(this, index)}
                />
              </td>
              <td className="text-center">{item.unit}</td>
              {recordType === "RECEIVED" && mode === "workdoc-po" ? (
                <td className="text-center">
                  {item.part_by === "garage"
                    ? "อู่"
                    : item.part_by === "branch"
                    ? "สาขา"
                    : item.part_by === "insurance"
                    ? "ประกัน"
                    : "ลูกค้า"}
                </td>
              ) : (
                ""
              )}
            </tr>
          );
        }
      });
    }
  }

  onPartByChange(field) {
    let { part_by, oriItem } = this.state;
    if (part_by[field]) part_by[field] = false;
    else part_by[field] = true;

    let newItem = [];
    let newItemCheck = [];
    if (
      !part_by.garage &&
      !part_by.branch &&
      !part_by.insurance &&
      !part_by.customer
    ) {
      newItem = oriItem;
      newItemCheck = newItem.map((item, index) => {
        return false;
      });
    } else {
      oriItem.forEach((item, index) => {
        if (item.part_by === "garage" && part_by.garage) {
          newItem.push(item);
          newItemCheck.push(false);
        } else if (item.part_by === "branch" && part_by.branch) {
          newItem.push(item);
          newItemCheck.push(false);
        } else if (item.part_by === "insurance" && part_by.insurance) {
          newItem.push(item);
          newItemCheck.push(false);
        } else if (item.part_by === "customer" && part_by.customer) {
          newItem.push(item);
          newItemCheck.push(false);
        }
      });
    }
    this.setState({
      part_by: part_by,
      receiveCheckAll: false,
      receiveCheck: newItemCheck,
      itemReceived: newItem,
    });
  }

  renderReceiveDetail() {
    let { input, part_by, oriItem,config } = this.state;
    let { recordType, mode, messages } = this.props;
    return (
      <form>
        <Row>
          <Col md={2}>
            <FormGroup>
              <ControlLabel>{messages["Document Number"]}</ControlLabel>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <FormControl
                type="text"
                placeholder={"<" + messages["Auto Generated Number"] + ">"}
                className="input-dark"
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup>
              <ControlLabel>
                {messages["Date"]}
                <span className="color-red">*</span>
              </ControlLabel>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <FormControl
                readOnly={true}
                type="text"
                placeholder=""
                className="input-dark"
                value={Moment()
                  .format("L LT")
                  .replace(Moment().format("YYYY"), yTh)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <FormGroup
              controlId={this.state.valid.request_by.id}
              validationState={this.state.valid.request_by.state}
            >
              <ControlLabel>
                {recordType === "RETURN"
                  ? messages["Return Name"]
                  : messages["Received Name"]}
                <span className="color-red">*</span>
              </ControlLabel>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup
              className={this.state.valid.request_by.has_error}
              controlId={null}
              validationState={null}
            >
              <CKAutocomplete
                top={"-34px"}
                items={this.state.customerList}
                value={this.state.input.request_by}
                onChange={this.onReceiveTextChange.bind(this, "request_by")}
                onSelect={this.onReceiveTextSelect.bind(this, "request_by")}
                onKeyPress={this.onReceiveTextKeyPress.bind(this, "request_by")}
              />
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup
              controlId={this.state.valid.response_by.id}
              validationState={this.state.valid.response_by.state}
            >
              <ControlLabel>
                {messages["Approvers"]}
                <span className="color-red">*</span>
              </ControlLabel>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup
              className={this.state.valid.response_by.has_error}
              controlId={null}
              validationState={null}
            >
              <CKAutocomplete
                top={"-34px"}
                items={this.state.customerList}
                value={this.state.input.response_by}
                onChange={this.onReceiveTextChange.bind(this, "response_by")}
                onSelect={this.onReceiveTextSelect.bind(this, "response_by")}
                onKeyPress={this.onReceiveTextKeyPress.bind(
                  this,
                  "response_by"
                )}
                ref="_response_by"
              />
            </FormGroup>
          </Col>
        </Row>
        {recordType === "RECEIVED" ? (
          <Row>
            <Col md={2}>
              <FormGroup
              controlId={this.state.valid.deliveryslip_no.id}
              validationState={this.state.valid.deliveryslip_no.state}              
              >
                <ControlLabel>เลขที่ใบส่งของ</ControlLabel>
                {config.required_fields.includes('deliveryslip_no') && (<span className="color-red">*</span>)}
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup 
              className={this.state.valid.deliveryslip_no.has_error}
              controlId={null}
              validationState={null}              
              >
                <FormControl
                  placeholder=""
                  value={this.state.input.deliveryslip_no}
                  onChange={this.onReceiveTextChange.bind(
                    this,
                    "deliveryslip_no"
                  )}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup
              controlId={this.state.valid.taxinvoice_no.id}
              validationState={this.state.valid.taxinvoice_no.state}                 
              >
                <ControlLabel>เลขที่ใบกำกับ</ControlLabel>
                {config.required_fields.includes('taxinvoice_no') && (<span className="color-red">*</span>)}
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup style={{ marginBottom: "0" }}>
                <Checkbox
                  onChange={this.onDeliveryChange.bind(this)}
                  checked={this.state.isDelivery}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=" เลขที่เดียวกับใบส่งของ"
                />
              </FormGroup>
              <FormGroup 
              className={this.state.valid.taxinvoice_no.has_error}
              controlId={null}
              validationState={null}                    
              >
                <FormControl
                  placeholder=""
                  disabled={this.state.isDelivery}
                  value={this.state.input.taxinvoice_no}
                  onChange={this.onReceiveTextChange.bind(
                    this,
                    "taxinvoice_no"
                  )}
                />
              </FormGroup>
            </Col>
          </Row>
        ) : (
          ""
        )}
        <Row>
          <Col md={2}>
            <FormGroup>
              <ControlLabel>{messages["Description"]}</ControlLabel>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <FormControl
                type="text"
                placeholder=""
                value={this.state.input.description}
                onChange={this.onReceiveTextChange.bind(this, "description")}
                ref="_description"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <FormGroup controlId={null} validationState={null}>
              <ControlLabel>{messages["Check Barcode"]}</ControlLabel>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup controlId={null} validationState={null}>
              <FormControl
                type="text"
                placeholder=""
                value={this.state.input.barcode}
                onChange={this.onReceiveTextChange.bind(this, "barcode")}
                onKeyPress={this.onReceiveSearchKeyPress.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <p style={{ color: this.state.barcodeMsgColor }}>
              {this.state.barcodeMsg}
            </p>
          </Col>
        </Row>
        {mode === "workdoc-po" && recordType === "RECEIVED" ? (
          <Row>
            <Col md={12}>
              {messages["Part By"]}&nbsp;
              {oriItem.findIndex((x) => x.part_by === "garage") !== -1 ? (
                <span>
                  <Checkbox
                    onChange={this.onPartByChange.bind(this, "garage")}
                    checked={part_by.garage}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=" อู่"
                  ></Checkbox>
                  &nbsp;
                </span>
              ) : (
                ""
              )}
              {oriItem.findIndex((x) => x.part_by === "branch") !== -1 ? (
                <span>
                  <Checkbox
                    onChange={this.onPartByChange.bind(this, "branch")}
                    checked={part_by.branch}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=" สาขา"
                  ></Checkbox>
                  &nbsp;
                </span>
              ) : (
                ""
              )}
              {oriItem.findIndex((x) => x.part_by === "insurance") !== -1 ? (
                <span>
                  <Checkbox
                    onChange={this.onPartByChange.bind(this, "insurance")}
                    checked={part_by.insurance}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=" ประกัน"
                  ></Checkbox>
                  &nbsp;
                </span>
              ) : (
                ""
              )}
              {oriItem.findIndex((x) => x.part_by === "customer") !== -1 ? (
                <span>
                  <Checkbox
                    onChange={this.onPartByChange.bind(this, "customer")}
                    checked={part_by.customer}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=" ลูกค้า"
                  ></Checkbox>
                </span>
              ) : (
                ""
              )}
            </Col>
          </Row>
        ) : (
          ""
        )}
      </form>
    );
  }

  rendertab() {
    let { title, messages } = this.props;
    let tabtitle = messages["_Select Item"] + title;
    return (
      <Tabs
        defaultActiveKey={this.state.tabKey}
        activeKey={this.state.tabKey}
        id="uncontrolled-tab-example"
        onSelect={(k) => this.setState({ tabKey: k })}
      >
        <Tab eventKey="home" title={tabtitle}>
          <div>{this.renderReceiveTable()}</div>
        </Tab>

        {this.state.auto_create_stock ? (
          <Tab eventKey="create-auto" title="รายการสร้างสินค้าอัตโนมัติ">
            <div>{this.renderAutoReceiveTable()}</div>
          </Tab>
        ) : null}
      </Tabs>
    );
  }
  renderReceiveTable() {
    let { recordType, messages, mode } = this.props;
    return (
      <div>
        <div className="table-po" style={{ overflowX: "auto" }}>
          <table className="table table-hover table-bordered-solid">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "50px" }}>
                  <Checkbox
                    onChange={this.onReceiveChange.bind(this, "all")}
                    checked={this.state.receiveCheckAll}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=""
                  ></Checkbox>
                </th>
                <th className="text-center" style={{ width: "50px" }}>
                  {messages["No"]}
                </th>
                <th className="text-center" style={{ width: "100px" }}>
                  {messages["Product Code"]}
                </th>
                <th className="text-center" style={{ width: "300px" }}>
                  {messages["Item"]}
                </th>
                {recordType !== "RETURN" ? (
                  <th className="text-center" style={{ width: "90px" }}>
                    {messages["Quantity"]} <br /> (
                    {recordType === "RECEIVED"
                      ? messages["Received"]
                      : recordType === "EXPORTWORK"
                      ? messages["Exported Work"]
                      : messages["Imported Stock"]}
                    )
                  </th>
                ) : (
                  ""
                )}
                <th className="text-center" style={{ width: "90px" }}>
                  {messages["Quantity"]}
                </th>
                <th className="text-center" style={{ width: "90px" }}>
                  หน่วย
                </th>
                {recordType === "RECEIVED" && mode === "workdoc-po" ? (
                  <th className="text-center" style={{ width: "100px" }}>
                    {messages["Part By"]}
                  </th>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            <tbody>{this.renderReceiveRowData()}</tbody>
            <tfoot>
              <tr>
                <th className="text-center">{messages["All"]}</th>
                <th className="text-center">{messages["No"]}</th>
                <th className="text-center">{messages["Product Code"]}</th>
                <th className="text-center">{messages["Item"]}</th>
                {recordType !== "RETURN" ? (
                  <th className="text-center">
                    {messages["Quantity"]} <br /> (
                    {recordType === "RECEIVED"
                      ? messages["Received"]
                      : recordType === "EXPORTWORK"
                      ? messages["Exported Work"]
                      : messages["Imported Stock"]}
                    )
                  </th>
                ) : (
                  ""
                )}
                <th className="text-center">{messages["Quantity"]}</th>
                <th className="text-center" style={{ width: "90px" }}>
                  หน่วย
                </th>
                {recordType === "RECEIVED" && mode === "workdoc-po" ? (
                  <th className="text-center" style={{ width: "100px" }}>
                    {messages["Part By"]}
                  </th>
                ) : (
                  ""
                )}
              </tr>
            </tfoot>
          </table>
        </div>
        <div>
          {this.state.show_auto_create_stock &&
          this.props.recordType === "IMPORT_STOCK" ? (
            <Form inline>
              <FormGroup>
                <Checkbox
                  onChange={this.onAutoCreateStockChange.bind(this)}
                  checked={this.state.auto_create_stock}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={" " + messages["Automatic Create"]}
                ></Checkbox>
              </FormGroup>{" "}
              {this.state.auto_create_stock ? (
                <FormGroup>
                  <Select
                    clearable={false}
                    options={this.optionsToolType}
                    value={this.state.toolType}
                    onChange={this.onToolTypeChange.bind(this)}
                    style={{ width: "130px" }}
                  />
                </FormGroup>
              ) : (
                ""
              )}
            </Form>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderAutoReceiveTable() {
    let { recordType, messages, mode } = this.props;

    return (
      <div>
        <div className="table-po" style={{ overflowX: "auto" }}>
          <table className="table table-hover table-bordered-solid">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "50px" }}>
                  <Checkbox
                    onChange={this.onAutoReceiveChange.bind(this, "all")}
                    checked={this.state.receiveAutoCheckAll}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=""
                  ></Checkbox>
                </th>
                <th className="text-center" style={{ width: "50px" }}>
                  {messages["No"]}
                </th>
                <th className="text-center" style={{ width: "100px" }}>
                  {messages["Product Code"]}
                </th>
                <th className="text-center" style={{ width: "300px" }}>
                  {messages["Item"]}
                </th>
                {recordType !== "RETURN" ? (
                  <th className="text-center" style={{ width: "90px" }}>
                    {messages["Quantity"]} <br /> (
                    {recordType === "RECEIVED"
                      ? messages["Received"]
                      : recordType === "EXPORTWORK"
                      ? messages["Exported Work"]
                      : messages["Imported Stock"]}
                    )
                  </th>
                ) : (
                  ""
                )}
                <th className="text-center" style={{ width: "90px" }}>
                  {messages["Quantity"]}
                </th>
                <th className="text-center" style={{ width: "90px" }}>
                  หน่วย
                </th>
                {recordType === "RECEIVED" && mode === "workdoc-po" ? (
                  <th className="text-center" style={{ width: "100px" }}>
                    {messages["Part By"]}
                  </th>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            <tbody>{this.renderAutoReceiveRowData()}</tbody>
            <tfoot>
              <tr>
                <th className="text-center">{messages["All"]}</th>
                <th className="text-center">{messages["No"]}</th>
                <th className="text-center">{messages["Product Code"]}</th>
                <th className="text-center">{messages["Item"]}</th>
                {recordType !== "RETURN" ? (
                  <th className="text-center">
                    {messages["Quantity"]} <br /> (
                    {recordType === "RECEIVED"
                      ? messages["Received"]
                      : recordType === "EXPORTWORK"
                      ? messages["Exported Work"]
                      : messages["Imported Stock"]}
                    )
                  </th>
                ) : (
                  ""
                )}
                <th className="text-center">{messages["Quantity"]}</th>
                <th className="text-center" style={{ width: "90px" }}>
                  หน่วย
                </th>
                {recordType === "RECEIVED" && mode === "workdoc-po" ? (
                  <th className="text-center" style={{ width: "100px" }}>
                    {messages["Part By"]}
                  </th>
                ) : (
                  ""
                )}
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }

  render() {
    let { show, title, recordType, messages } = this.props;
    let { itemReceived, itemReturn } = this.state;
    let isCheckBtn = [];
    isCheckBtn = recordType === "RETURN" ? itemReturn : itemReceived;
    return (
      <Modal
        bsSize="large"
        show={show}
        onHide={this.props.onHide}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {messages["_Select Item"]}
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderReceiveDetail()}
          {this.rendertab()}
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle={"danger"}
            onClick={this.onReceivePrintClick.bind(this)}
          >
            <FontAwesome name="print" />
            &nbsp;{messages["_Print"]}
            {title}
          </Button>
          <Button
            bsStyle={"primary"}
            disabled={isCheckBtn.length > 0 ? false : true}
            onClick={this.onReceiveClick.bind(this)}
          >
            <FontAwesome name="save" />
            &nbsp;{messages["_Save"]}
            {title}
          </Button>
          <Button
            onClick={() => {
              this.onCancelClick();
            }}
          >
            <FontAwesome name="close" />
            &nbsp;{messages["Cancel"]}
          </Button>
        </Modal.Footer>
        <NotificationSystem ref="notificationSystem" />
        <IframeModal ref="iframe" title={messages["Print Document"]} />
      </Modal>
    );
  }
}

POOutstandingRecordModal.defaultProps = {
  show: false,
  title: "",
  mode: "po",
};
export default connect(
  (state) => ({ messages: state.message.view.po.POOutstandingRecordModal }),
  null,
  null,
  { withRef: true }
)(POOutstandingRecordModal);



// WEBPACK FOOTER //
// ./src/view/po/POOutstandingRecordModal.js